import React from "react";
import { Link } from "react-router-dom";
import {MdPeopleAlt, MdPersonAdd, MdOutlineCalculate} from 'react-icons/md'

const Sidebar = () => {
  return (
    <div>
      <aside className="sidebar">
        <div className="sidebar-nav">
        <Link><MdPeopleAlt /> Users</Link>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
